<template>
  <a :href="reverseFull({ name: 'prodoctorov_main' })">
    <v-img
      contain
      width="236"
      height="36"
      :src="logoPath"
    />
  </a>
</template>

<script setup lang="ts">
import { computed, Ref } from 'vue'
import { useURLStore, useContextStore } from 'src/store'
import type { ContextStore } from 'src/layouts/core-layout/types'

const { context }: ContextStore = useContextStore()
const { reverseFull } = useURLStore()
const { src, media } = context.global.static

const logoPath: Ref<string> = computed(() => {
  if (!context.request.country.is_russia) {
    return new URL(context.request.country.site_logo, media).href
  }

  if (context.site_settings.show_event_site_logo) {
    return `${src}_v1/pd/logos/ui-kit/prodoctorov-event-logo.svg`
  }

  return `${src}_v1/pd/logos/ui-kit/prodoctorov-logo.svg`
})
</script>
